import { AppThunk } from '../../../store/rootReducer';
import { trackChangeLead } from '../../analytics/thunks/track-change-lead.thunk';
import { AnalyticsPlot } from '../../analytics/types/analytics.types';
import { leadNamesSelector } from '../../ecg/selectors/signal.selectors';
import { designatedMeanSelector } from '../../raw-signal/selectors/raw-signal.selectors';
import * as stripActions from '../actions/strip.actions';
import { stripByIdSelector } from '../selectors/strip.selectors';
import { StripId } from '../types/strip.type';
import { isOfTypeChangeLead } from '../utils/graph.utils';

export const navigateLead =
  (
    stripId: StripId,
    plotName: AnalyticsPlot | undefined,
    currLead: string,
    nextLead: string,
  ): AppThunk =>
  async (dispatch, getState) => {
    const strip = stripByIdSelector(stripId)(getState());
    const leadNames = leadNamesSelector(getState());

    if (strip == null) {
      return;
    }

    if (!leadNames.includes(currLead) || !leadNames.includes(nextLead)) {
      return;
    }

    const stripLeads = strip.leads.slice();
    stripLeads[0] = nextLead;
    const mean = designatedMeanSelector(stripId, nextLead)(getState());

    if (isOfTypeChangeLead(plotName)) {
      dispatch(trackChangeLead([nextLead], [currLead], plotName));
    }

    dispatch(
      stripActions.update({ stripId, strip: { leads: stripLeads, mean } }),
    );
  };
